import * as moment from "moment-timezone";

export class CustomDatePayload {
    typeValue: string;
    date: moment.Moment;
}